import { DsTab, DsTabList, DsTabPanel, DsTabPanels, DsTabs } from '@frontends/ds';
import { useTranslation } from 'react-i18next';

export const CertificatesTabs = ({
  children,
  activeTab,
  onTabChange,
  tabs,
}: {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: { value: string; label: string }[];
}) => {
  const { t } = useTranslation();

  return (
    <DsTabs className="gap-5" selectedKey={activeTab} onSelectionChange={(key) => onTabChange(String(key))}>
      <DsTabList aria-label={t('certificates_title')}>
        {tabs.map((tab) => (
          <DsTab key={tab.value} id={tab.value}>
            {tab.label}
          </DsTab>
        ))}
      </DsTabList>
      <DsTabPanels className="overflow-visible">
        <DsTabPanel key={activeTab} id={activeTab} className="p-0">
          {children}
        </DsTabPanel>
      </DsTabPanels>
    </DsTabs>
  );
};
